/**
 * Protected-route error chrome. Scout live www desktop 2026-09-09
 * `04-05-nutrition-error.png`: Layout/sidebar stayed mounted (Nutrition
 * highlighted) while the main pane showed this exact copy and the three
 * recovery actions. Keep these strings the single source for App + tests.
 */

export const PROTECTED_ROUTE_ERROR_TITLE = 'This page could not load';

export const PROTECTED_ROUTE_ERROR_DESCRIPTION =
  'Something went wrong while showing this screen. Try again or return to your dashboard.';

export const PROTECTED_ROUTE_ERROR_RETRY_LABEL = 'Try again';

export const PROTECTED_ROUTE_ERROR_RELOAD_LABEL = 'Reload page';

export const PROTECTED_ROUTE_ERROR_DASHBOARD_LABEL = 'Back to dashboard';
